<template>
  <v-overlay :value="overlay" z-index="1000">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
</template>

<script>
import { handleOAuth } from "../modules/bank-oauth-handler";

export default {
  data: () => ({
    overlay: false,
  }),
  name: "callback",
  async created() {
    this.overlay = true;
    window.location.href = "https://kh.portal.bankszamlakivonat.hu/accounts"
    
  },
};
</script>
